import React, { useState } from "react";
import ModalTemplate from "./template";
import { useForm } from "react-hook-form";
import Input from "../form/input";
import Button from "../button";
import Select from "../form/select";
import { useDispatch, useSelector } from "react-redux";
import { hideModal, setModal } from "../../../redux/actions/modals";
import { TIMESLOT_DETIAL_MODAL } from "./constants";
import { State } from "../../../redux/reducers/root";
import { ModalPayload } from "../../../redux/models/modals";
import { addNewUser } from "../../../redux/actions/add-user";
import Dialog from "../dialog/dialog";
import { searchUser } from "../../../redux/actions/search-user";
interface Inputs {
  firstName: string;
  lastName: string;
  gender: number;
}
const RegisterUserModal = () => {
  const {
    handleSubmit,
    register,
    control,
    clearErrors,
    formState: { errors, isValid, isSubmitting },
  } = useForm<Inputs>({ mode: "onChange" });

  const modals = useSelector((state: State) => state.modals) as ModalPayload;
  const tel = modals.data?.tel;
  const timeslot = modals.data?.timeslot;
  const type = modals.data?.type;
  const dispatch = useDispatch();
  const [error, setError] = useState(false);

  const genderOptions = [
    { id: 0, value: 0, label: "زن" },
    { id: 1, value: 1, label: "مرد" },
  ];

  const handleCancle = () => {
    if (type === "booking") dispatch(setModal({ modal: TIMESLOT_DETIAL_MODAL, data: { timeslot }, visible: true }));
    else {
      clearErrors(["firstName", "lastName", "gender"]);
      dispatch(hideModal());
    }
  };

  const submitUser = async (values: Inputs) => {
    try {
      await dispatch(addNewUser({ ...values, tel }));
      if (type === "booking")
        await dispatch(setModal({ modal: TIMESLOT_DETIAL_MODAL, data: { timeslot, tel }, visible: true }));
      else {
        await dispatch(searchUser(tel));
        dispatch(hideModal());
      }
    } catch (e) {
      setError(true);
    }
  };

  return (
    <ModalTemplate title="ثبت اطلاعات مراجعه کننده جدید" icon="fa fa-calendar-alt">
      <Dialog className="overflow-hidden rounded-3xl" show={error} onClose={() => setError(false)}>
        <p className="flex items-center justify-center h-16 text-pkc-red ">خطا در ثبت کاربر</p>
      </Dialog>
      <hr className="my-4" />
      <div className="p-2 font-medium border-solid rounded-md bg-pkc-clear-blue-15 border-1 border-pkc-clear-blue-15 text-pkc-clear-blue">
        این کاربر قبلا در سایت ثبت‌نام نشده است. لطفا اطلاعات زیر را تکمیل فرمایید.
      </div>
      <hr className="my-4" />
      <form onSubmit={handleSubmit(submitUser)} className="flex flex-col">
        <div className="flex flex-col text-sm font-medium">
          <Input
            type="text"
            placeholder="نام مراجعه کننده را وارد کنید"
            label="نام"
            error={errors.firstName}
            inputClassName="font-medium"
            {...register("firstName", { required: true })}
          />
          {errors.firstName && <div className="mb-4 mr-3 text-red-500 ">لطفا نام را وارد کنید !</div>}

          <Input
            type="text"
            placeholder="نام خانوادگی مراجعه کننده را وارد کنید"
            label="نام خانوادگی"
            error={errors.lastName}
            inputClassName="font-medium"
            {...register("lastName", { required: true })}
          />
          {errors.lastName?.type === "required" && (
            <div className="mb-4 mr-3 text-red-500 ">لطفا نام خانوادگی را وارد کنید !</div>
          )}

          <Select
            rules={{ required: true }}
            className="py-2 text-sm font-medium "
            containerClassName="flex flex-col"
            label="جنسیت"
            labelClassName="text-sm mb-2 font-medium text-pkc-greyish-brown"
            control={control}
            options={genderOptions}
            isSearchable={true}
            name="gender"
          />
          {errors.gender && <div className="mb-4 mr-3 text-red-500 ">لطفا جنسیت را انتخاب کنید !</div>}
        </div>
        <div className="grid grid-cols-2 grid-rows-1 pt-6 gap-x-2">
          <Button
            type="button"
            className="flex-1 !text-pkc-form-icon !border-pkc-form-icon"
            variant="outline"
            onClick={handleCancle}
          >
            انصراف
          </Button>
          <Button type="submit" className="flex-1" variant="contained" loading={isSubmitting} disabled={!isValid}>
            ثبت اطلاعات و ادامه
          </Button>
        </div>
      </form>
    </ModalTemplate>
  );
};

export default RegisterUserModal;
